<template>

  <div>
    <!-- Split dropup button -->
    <div
      v-if="permissions.includes('manage_jobs')"
      class="btn-group">
      <button
        type="button"
        @click="showEditModal(job)"
        class="btn btn-light">
        {{ $t('Edit') }}
        </button>
      <button
        type="button"
        class="btn btn-light dropdown-toggle dropdown-toggle-split"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div
        class="dropdown-menu dropdown-menu-right">
        <button
          class="dropdown-item"
          @click="clone()">{{ $t('Clone') }}</button>
        <hr>
        <button
          class="dropdown-item"
          @click="open()"
          v-if="job.status !== 'open'">Abrir</button>
        <button
          class="dropdown-item"
          @click="archived()"
          v-if="job.status !== 'archived'">{{ $t('Archive') }}</button>
      </div>
    </div>

    <job-form 
      :initJob="modal_select" 
      @hideModal="hideModal()" 
      @deleted="deleted" 
      @saved="hideModal()"
      v-if="modal_select"
      ></job-form>

    <job-cancel-reasons
      @hideModal="hideCancelModal()"
      v-if="modal_cancel_select">
      </job-cancel-reasons>

  </div>

</template>

<script>
import JobForm from '@/components/JobForm/JobForm'
import JobCancelReasons from './JobCancelReasons'

export default {
  name: 'JobOptions',
  components: {
    JobForm,
    JobCancelReasons
  },
  props: [
    'selected'
  ],
  data () {
    return {
      modal_select: false,
      modal_cancel_select: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
    /*
    open
    */
    open () {
      this.$store.dispatch('updateJobOpen', {
        _id: this.job._id
      })
    },
    /*
    archived
    */
    archived () {
      if (this.job.pipeline.hired >= this.job.openings) {
        this.$store.dispatch('updateJobArchive', {
          _id: this.job._id
        })
      } else {
        this.showCancelModal()
      }
    },
    /*
    showEditModal
    */
    showEditModal (item) {
      this.modal_select = item
    },
    /*
    hideModal
    */
    hideModal () {
      this.modal_select = false
    },
    /*
    showEditModal
    */
    showCancelModal () {
      this.modal_cancel_select = true
    },
    /*
    hideModal
    */
    hideCancelModal () {
      this.modal_cancel_select = false
    },
    /*
    deleted
    */
    deleted () {
      this.$router.push('/')
    },
    /*
    clone
    */
    clone () {
      this.$store
      .dispatch('cloneJob', this.job._id)
      .then((result) => {
        this.$router.push('/job/' + result._id)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobHeader/JobOptions.vue